import React, { useState, useEffect, useRef } from 'react';
import { Space, Breadcrumb, Row, Col, Table, Spin, Button } from 'antd';
import { CardLayout, 
  Calender, 
  TableWrapper, 
  ProjectScheduleEditModal, 
  StandbyScheduleEditModal,
  B2cScheduleEditModal, 
  B2cPmlEditModal, 
  SeminarScheduleEditModal,
  ProjectDiagnoseEditModal } from 'components/molecules';
import SearchBox from './SearchBox'
import moment, { Moment } from 'moment'
import { useSchedule } from 'hooks';
import { useLocation, useNavigate } from 'react-router';
import qs from 'query-string';
import { addNewSearch } from 'utils/utils';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import * as XLSX from 'xlsx';
import { isMobile } from 'react-device-detect';
import useStore from 'store';

export interface  ScheduleProps {
}

const  Schedule = ({}:  ScheduleProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [searchDate, setSearchDate] = useState<string>(moment().format('YYYY-MM-DD')); 
  const [scheduleData, setScheduleData] = useState<ScheduleListDto[]>([]);
  const [isLoding, setIsLoading] = useState<boolean>(false);   
  const [display, setDisplay] = useState<string>('month'); 
  const auth = useStore((state) => state.auth); 

  const { scheduleList, lectureSummerList, lecturerTotal, weekList, refetch } = useSchedule()
  const boxRef = useRef<HTMLDivElement>(null);

  const columns: ColumnsType<LecturerSummeryDto> = [
    {
      title: '강사',
      dataIndex: 'lecturer_name',
      key: 'lecturer_name',
      width: 100,
      align: 'center',
      fixed: 'left',
      sorter: (a, b) => a.lecturer_name.localeCompare(b.lecturer_name),
    },   
    {
      title: '월 강의시간',
      children: [
        {
          title: '확정',
          dataIndex: 'time1',
          key: 'time1',
          align: 'center',
          width: isMobile?'60px':'auto',
        },  
        {
          title: '미확정',
          dataIndex: 'time2',
          key: 'time1',
          align: 'center',
          width: isMobile?'60px':'auto',
        },  
        {
          title: '합계',
          key: 'time_total',
          align: 'center',
          width: isMobile?'60px':'auto',
          sorter: (a, b) => (a.time1 + a.time2) - (b.time1 + b.time2), 
          render: (record) => {
            return (
              record.time1 + record.time2
            )
          }              
        },           
      ]
    },   
    {
      title: '평점',
      children: [
        {
          title: '5점',
          dataIndex: 'avg5',
          key: 'avg5',
          align: 'center',
          width: isMobile?'60px':'auto',
        },  
        {
          title: '7점',
          dataIndex: 'avg7',
          key: 'avg7',
          align: 'center',
          width: isMobile?'60px':'auto',
        },  
        {
          title: '10점',
          dataIndex: 'avg10',
          key: 'avg10',
          align: 'center',
          width: isMobile?'60px':'auto',
        },    
        {
          title: 'NPS',
          dataIndex: 'nps',
          key: 'nps',
          align: 'center',
          width: isMobile?'60px':'auto',
        },                                       
      ]
    }, 
    {
      title: '주 강의시간(그린라이트)',
      children:
      weekList.map((item, index) => {
        return {
          title: item.sdt+' ~ '+item.edt,
          dataIndex: 'WEEK'+(index+1),
          key: 'WEEK'+(index+1),
          align: 'center',
          width: isMobile?'60px':'auto',
          render(text, record) {
            return {
              props: {
                style: { 
                  background: (index===0 && record.GREEN1 || index===1 && record.GREEN2 || index===2 && record.GREEN3 || index===3 && record.GREEN4 || index===4 && record.GREEN5 || index===5 && record.GREEN6) ? '#090' : "white" ,
                  color: (index===0 && record.GREEN1 || index===1 && record.GREEN2 || index===2 && record.GREEN3 || index===3 && record.GREEN4 || index===4 && record.GREEN5 || index===5 && record.GREEN6) ? 'white' : "black" 
                }
                  
              },
              children: <div>{text}</div>
            };
          }          
        }}
      ),
    },         
  ];

  /* ======================================================
   * hooks
   * ====================================================== */

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { open } = usePopupManager();

  /* ======================================================
   * events
   * ====================================================== */    
  const prevMonth = () => {
    const date = moment(searchDate).add(-1, display as any).format('YYYY-MM-DD');
    setSearchDate(date);
    setScheduleData([]); 
    navigate({
      ...location,
      search: addNewSearch(location.search, { searchDateStart: date }),
    });    
  };
  const nextMonth = () => {
    const date = moment(searchDate).add(1, display as any).format('YYYY-MM-DD');
    setSearchDate(date);
    setScheduleData([]); 
    navigate({
      ...location,
      search: addNewSearch(location.search, { searchDateStart: date }),
    }); 
  };

  const onSetSearchDate = (date: any) => {
    setSearchDate(date);
    setScheduleData([]); 
    navigate({
      ...location,
      search: addNewSearch(location.search, { searchDateStart: date }),
    }); 
  };  

  const onGoDay= (date: any) => {
    setSearchDate(date);
    setScheduleData([]); 
    navigate({
      ...location,
      search: addNewSearch(location.search, { searchDateStart: date, type: 'day' }),
    }); 
  };    

  const onChangeDisplay = (e: any) => {
    setDisplay(e.target.value);
    setScheduleData([]); 
    navigate({
      ...location,
      search: addNewSearch(location.search, { type: e.target.value }),
    });     
  }  

  const makePopupContent = (item: DailyScheduleDto) => {
    if (item.status === 'standby') {
      return (
        <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
        <Row>
          <Col flex={'80px'}>◦일정명</Col>
          <Col flex={'220px'}>{item.project_title}</Col>
        </Row>    
        <Row>
          <Col flex={'80px'}>◦강의구분</Col>
          <Col flex={'220px'}>{item.lecture_type}</Col>
        </Row>     
        <Row>
          <Col flex={'80px'}>◦주제</Col>
          <Col flex={'220px'}>{item.lecture_subject}</Col>
        </Row>     
        <Row>
          <Col flex={'80px'}>◦강의시간</Col>
          <Col flex={'220px'}>{item.start_time}~{item.end_time}</Col>
        </Row>         
        <Row>
          <Col flex={'80px'}>◦강사명</Col>
          <Col flex={'220px'}>{item.lecturer_name}</Col>
        </Row> 
        <Row>
          <Col flex={'80px'}>◦강의상태</Col>
          <Col flex={'220px'}><span className={'lecture_status_type_' + item.lecture_status_type}>● <span style={{color:'#000'}}>대기</span></span></Col>
        </Row>   
        {isMobile && (
        <div style={{marginTop: 10, display:'flex', justifyContent: 'space-between'}}>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
            }}>닫기
          </Button>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
              onClickInfo(item)
            }} type='primary'>일정보기
          </Button>
        </div>    
        )}
      </div>
      )
    } else if (item.project_type === 'b2b') {
      return (
        <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
        <Row>
          <Col flex={'80px'}>◦기업명</Col>
          <Col flex={'220px'}>{item.company_name}</Col>
        </Row> 
        <Row>
          <Col flex={'80px'}>◦프로젝트명</Col>
          <Col flex={'220px'}>{item.project_title}</Col>
        </Row>    
        <Row>
          <Col flex={'80px'}>◦강의구분</Col>
          <Col flex={'220px'}>{item.lecture_type}</Col>
        </Row>     
        <Row>
          <Col flex={'80px'}>◦주제</Col>
          <Col flex={'220px'}>{item.lecture_subject}</Col>
        </Row>     
        <Row>
          <Col flex={'80px'}>◦강의시간</Col>
          <Col flex={'220px'}>{item.start_time}~{item.end_time} {'('}{item.time_count}{'시간)'}</Col>
        </Row>         
        <Row>
          <Col flex={'80px'}>◦강사명</Col>
          <Col flex={'220px'}>{item.lecturer_name}</Col>
        </Row> 
        <Row>
          <Col flex={'80px'}>◦강의장소</Col>
          <Col flex={'220px'}>{item.lecture_place}</Col>
        </Row>         
        <Row>
          <Col flex={'80px'}>◦강의대상</Col>
          <Col flex={'220px'}>{item.target}</Col>
        </Row>
        <Row>
          <Col flex={'80px'}>◦강의상태</Col>
          <Col flex={'220px'}><span className={'lecture_status_type_' + item.lecture_status_type}>● <span style={{color:'#000'}}>{`${item.lecture_status_type == '4'?'논의중':item.lecture_status_type == '0'?'대기':'확정'}`}</span></span></Col>
        </Row>   
        <Row>
          <Col flex={'80px'}>◦운영</Col>
          <Col flex={'220px'}>{item.operator}</Col>
        </Row>     
        {isMobile && (
        <div style={{marginTop: 10, display:'flex', justifyContent: 'space-between'}}>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
            }}>닫기
          </Button>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
              onClickInfo(item)
            }} type='primary'>일정보기
          </Button>
        </div>    
        )}
      </div>
      )
    } else if (item.project_type === 'b2b_pml') {
      return (
        <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
        <Row>
          <Col flex={'80px'}>◦기업명</Col>
          <Col flex={'220px'}>{item.company_name}</Col>
        </Row> 
        <Row>
          <Col flex={'80px'}>◦프로젝트명</Col>
          <Col flex={'220px'}>{item.project_title}</Col>
        </Row>    
        <Row>
          <Col flex={'80px'}>◦디브리핑</Col>
          <Col flex={'220px'}>{item.start_time}~{item.end_time} {'('}{item.time_count}{'시간)'}</Col>
        </Row>         
        <Row>
          <Col flex={'80px'}>◦강사명</Col>
          <Col flex={'220px'}>{item.lecturer_name}</Col>
        </Row> 
        <Row>
          <Col flex={'80px'}>◦진단대상</Col>
          <Col flex={'220px'}>{item.target}</Col>
        </Row>
        <Row>
          <Col flex={'80px'}>◦진단상태</Col>
          <Col flex={'220px'}><span className={'lecture_status_type_' + item.lecture_status_type}>● <span style={{color:'#000'}}>{`${item.lecture_status_type == '4'?'논의중':item.lecture_status_type == '0'?'대기':'확정'}`}</span></span></Col>
        </Row>  
        {isMobile && (
        <div style={{marginTop: 10, display:'flex', justifyContent: 'space-between'}}>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
            }}>닫기
          </Button>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
              onClickInfo(item)
            }} type='primary'>일정보기
          </Button>
        </div>    
        )}         
      </div>
      )
    } else if (item.project_type === 'b2c') {
      return (
        <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
        <Row>
          <Col flex={'80px'}>◦과정명</Col>
          <Col flex={'220px'}>{item.project_title}</Col>
        </Row>    
        <Row>
          <Col flex={'80px'}>◦주제</Col>
          <Col flex={'220px'}>{item.lecture_subject}</Col>
        </Row>     
        <Row>
          <Col flex={'80px'}>◦강의시간</Col>
          <Col flex={'220px'}>{item.start_time}~{item.end_time} {'('}{item.time_count}{'시간)'}</Col>
        </Row>         
        <Row>
          <Col flex={'80px'}>◦강사명</Col>
          <Col flex={'220px'}>{item.lecturer_name}</Col>
        </Row> 
        <Row>
          <Col flex={'80px'}>◦강의장소</Col>
          <Col flex={'220px'}>{item.lecture_place}</Col>
        </Row>         
        <Row>
          <Col flex={'80px'}>◦강의인원</Col>
          <Col flex={'220px'}>{item.target}명</Col>
        </Row>
        <Row>
          <Col flex={'80px'}>◦강의상태</Col>
          <Col flex={'220px'}><span className={'lecture_status_type_' + item.lecture_status_type}>● <span style={{color:'#000'}}>확정</span></span></Col>
        </Row>   
        <Row>
          <Col flex={'80px'}>◦운영</Col>
          <Col flex={'220px'}>{item.operator}</Col>
        </Row>     
        <Row>
          <Col flex={'80px'}>◦평가</Col>
          <Col flex={'220px'}>{'NPS: '}{item.nps_evaluation}{'%'}&nbsp;&nbsp;&nbsp;{'강의평점: '}{item.class_evaluation}{'/'}{item.class_evaluation_max}</Col>
        </Row>  
        {isMobile && (
        <div style={{marginTop: 10, display:'flex', justifyContent: 'space-between'}}>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
            }}>닫기
          </Button>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
              onClickInfo(item)
            }} type='primary'>일정보기
          </Button>
        </div>    
        )}                                                                                                                                                                                                                                                                                                   
      </div>
      )
    } else if (item.project_type === 'b2c_pml') {
      return (
        <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
        <Row>
          <Col flex={'80px'}>◦과정명</Col>
          <Col flex={'220px'}>{item.project_title}</Col>
        </Row>    
        <Row>
          <Col flex={'80px'}>◦디브리핑</Col>
          <Col flex={'220px'}>{item.start_time}~{item.end_time} {'('}{item.time_count}{'시간)'}</Col>
        </Row>         
        <Row>
          <Col flex={'80px'}>◦강사명</Col>
          <Col flex={'220px'}>{item.lecturer_name}</Col>
        </Row> 
        <Row>
          <Col flex={'80px'}>◦진단인원</Col>
          <Col flex={'220px'}>{item.target}명</Col>
        </Row>
        <Row>
          <Col flex={'80px'}>◦진단상태</Col>
          <Col flex={'220px'}><span className={'lecture_status_type_' + item.lecture_status_type}>● 확정</span></Col>
        </Row>  
        {isMobile && (
        <div style={{marginTop: 10, display:'flex', justifyContent: 'space-between'}}>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
            }}>닫기
          </Button>
          <Button onClick={(e) => {
              const mouseOutEvent = new MouseEvent('mouseout', { bubbles: true, cancelable: true });
              // 버튼을 감싸고 있는 팝업 영역에 이벤트를 전달합니다.
              e.currentTarget.closest('.ant-popover')?.dispatchEvent(mouseOutEvent);             
              onClickInfo(item)
            }} type='primary'>일정보기
          </Button>
        </div>    
        )}         
      </div>
      )
    }
  }

  const onClickInfo = (item: DailyScheduleDto) => {
    if (item.project_type === 'b2b') {
      if (item.parent_id === 0 ) {
        open(StandbyScheduleEditModal, {
          id: item.id,
          onClose: (isOk) => {refetch();},
        }); 
      } else {
        open(ProjectScheduleEditModal, {
          group_id: item.parent_id,
          id: item.id,
          onClose: (isOk) => {refetch();},
        }); 
      }
    } else if (item.project_type === 'b2b_pml') {
      open(ProjectDiagnoseEditModal, {
        group_id: item.parent_id,
        id: item.id,
        pType: 'confirm',
        onClose: (isOk) => {
          if (isOk) {
            refetch();
          }
        },
      }); 
    } else if (item.project_type === 'b2c') {
      if (item.lecture_gid === 9999) {
        open(SeminarScheduleEditModal, {
          group_id: item.group_id,
          id: item.id,
          onClose: (isOk) => {
            if (isOk) {
              refetch();
            }
          },
        }); 
      } else {
        open(B2cScheduleEditModal, {
          group_id: item.group_id,
          id: item.id,
          onClose: (isOk) => {
            if (isOk) {
              refetch();
            }
          },
        }); 
      }
    } else if (item.project_type === 'b2c_pml') {
      open(B2cPmlEditModal, {id: item.id, onClose: (isOk)=>{if(isOk) {refetch();}}});   
    }
  };

  const onExcelDownload = () => {
    setIsLoading(true); 

    const schedules: DailyScheduleDto[] = [];
    scheduleData.forEach(item => {
      item.schedules.forEach(s => {
        schedules.push(s);
      })
    });
    const book = XLSX.utils.book_new();
    const nurses = XLSX.utils.json_to_sheet(
      schedules.map((item, index) => {
        return {
          '번호' : index+1,
          '날짜' : '20'+item.start_date,
          '요일': moment('20'+item.start_date).format('dddd'),
          '주제': item.lecture_subject,
          '기업명': (item.project_type==='b2c')?'HSG 공개과정':(item.project_type==='b2c_pml')?'HSG 성과백신':item.company_name,
          '강사명': item.lecturer_name,
          '강의시간': item.start_time+'~'+item.end_time+' ('+item.time_count+'시간)',
          '강의대상': (item.project_type==='b2b'||item.project_type==='b2b_pml')?item.target:item.target+'명',
          '프로젝트명': item.project_title,
          'PM': item.pm,
          'CM': item.cm,
          '상태': (item.status === 'confirm') ? '확정' : '논의중',
        }
      }), 
      { 
        header : [
          '번호',
          '날짜',
          '요일',
          '주제',
          '기업명',
          '강사명',
          '강의시간',
          '강의대상',
          '프로젝트명',
          'PM',
          'CM',
          '상태',
        ], 
        skipHeader : false 
      } 
    );

    nurses["!cols"] = [
      { wpx : 60 } 
    , { wpx : 100 } 
    , { wpx : 50 }  
    , { wpx : 120 }  
    , { wpx : 120 } 
    , { wpx : 80 } 
    , { wpx : 120 } 
    , { wpx : 120 } 
    , { wpx : 250 } 
    , { wpx : 80 } 
    , { wpx : 80 } 
    , { wpx : 80 } 
    ]

    XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
    if (scheduleData.length > 7) {
      XLSX.writeFile( book, moment(searchDate).format('YYYY년MM월_')+"강의일정.xlsx" ); 
    } else if (scheduleData.length > 1) {
      XLSX.writeFile( book, `${moment(scheduleData[0].date).format('YYYY년MM월DD일')}_${moment(scheduleData[scheduleData.length-1].date).format('YYYY년MM월DD일')}_강의일정.xlsx` ); 
    } else {
      XLSX.writeFile( book, moment(searchDate).format('YYYY년MM월DD일_')+"강의일정.xlsx" ); 
    }
    
    setIsLoading(false);   
  }

  /* ======================================================
   * hooks
   * ====================================================== */
  useEffect(() => {
    if (searchParams && searchParams.searchDateStart) {
      setSearchDate(String(searchParams.searchDateStart)); 
    } else {
      setSearchDate(moment().format('YYYY-MM-DD'));      
    }
    if (searchParams && searchParams.type) {
      setDisplay(String(searchParams.type)); 
    } else {
      setDisplay('month');
    }
    
  }, [searchParams]);  

  useEffect(() => {
    if (scheduleList) {
      setScheduleData(scheduleList); 
    } else {
      setScheduleData([]); 
    }
  }, [scheduleList]);  
  
  useEffect(() => {
    if (isMobile && auth && auth.login && auth.login.lecturer_srl) {
      setDisplay('day')
    }
  }, [auth]);    

  useEffect(() => {
    console.log('boxRef.current', boxRef.current);
    if (isMobile) {
      if (boxRef.current) {
        const cardBody = boxRef.current.querySelector('.ant-card-body') as HTMLDivElement | null;
        if (cardBody) {
          if ( display != 'month') {
            cardBody.scrollTo({
              top: 500, 
              behavior: 'smooth' // 즉시 이동은 'auto'
            });
          } else {
            cardBody.scrollTo({
              top: 0, 
              behavior: 'smooth' // 즉시 이동은 'auto'
            });          
          }
        }        
      }
    } else {
      if ( display != 'month') {
        window.scrollTo({
          // 카드 본문 시작점으로부터 원하는 높이만큼 더해서 스크롤을 내립니다.
          top: 600,
          behavior: 'smooth',
        });
      } else {
        window.scrollTo({
          // 카드 본문 시작점으로부터 원하는 높이만큼 더해서 스크롤을 내립니다.
          top: 0,
          behavior: 'smooth',
        });  
      }
    }
  }, [display]);    

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout 
      className='test'
      title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>강사일정</Breadcrumb.Item>
      </Breadcrumb>      
      )}
      ref={boxRef}
    >
        <Space direction="vertical" style={{ width: '100%', marginBottom:'20px'}}>
          
          <SearchBox />
          <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large" style={{minHeight:'500px'}}>
            <Calender 
              current={searchDate} 
              schedules={scheduleData} 
              type={'sc'}
              display={display}
              onChangeDisplay={onChangeDisplay}
              onPrevMonth={prevMonth} 
              onNextMonth={nextMonth} 
              onClickItem={onClickInfo}
              makePopupContent={makePopupContent}
              onExcelDownload={onExcelDownload}
              onSetSearchDate={onSetSearchDate}
              onGoDay={onGoDay}
              refetch={refetch}
            />
            {lecturerTotal  && (
            <Space direction="vertical" style={{ width: '100%',gap:'0px', margin:'20px 0px' }} size={'small'} >
              <p style={{marginBottom:'0px', fontWeight:'500', float:'right'}}>{'총 강의 ' + (lecturerTotal.time1+lecturerTotal.time2) + '시간 (확정: ' +  lecturerTotal.time1 + ', 미확정: ' + lecturerTotal.time2 + ')'}</p> 
              <p style={{marginBottom:'0px', fontWeight:'500', float:'right'}}>{'평균 NPS: ' + lecturerTotal.nps +'%'}</p> 
              <p style={{marginBottom:'0px', fontWeight:'500', float:'right'}}>{'평균 평점: ' + lecturerTotal.avg10 + '(10), ' + lecturerTotal.avg7 + '(7), ' + lecturerTotal.avg5 + '(5)'}</p> 
            </Space>
            )}
            <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
              <Table
                tableLayout="fixed"
                dataSource={lectureSummerList}
                columns={columns}
                pagination={false}
                style={{ width: '100%', overflowX: 'auto', minWidth: isMobile?"100px":"600px" }}
                className="columnCenterFixTable clickable schedule"
                showSorterTooltip={false}
                rowKey={'id'}
                summary={pageData => {
                  let tot_time1 = 0;
                  let tot_time2 = 0;
                  let tot_avg5 = 0;
                  let cnt_avg5 = 0;
                  let tot_avg7 = 0;
                  let cnt_avg7 = 0;
                  let tot_avg10 = 0;
                  let cnt_avg10 = 0;
                  let tot_nps = 0;
                  let cnt_nps = 0;
                  let tot_WEEK1 = 0;
                  let tot_WEEK2 = 0;
                  let tot_WEEK3 = 0;
                  let tot_WEEK4 = 0;
                  let tot_WEEK5 = 0;
                  let tot_WEEK6 = 0;

                  pageData.forEach(({ time1, time2, avg5, avg7, avg10, nps, WEEK1, WEEK2, WEEK3, WEEK4, WEEK5, WEEK6 }) => {
                    tot_time1 += time1;
                    tot_time2 += time2;
                    tot_avg5 += avg5;
                    tot_avg7 += avg7;
                    tot_avg10 += avg10;
                    tot_nps += nps;
                    tot_WEEK1 += WEEK1 || 0;
                    tot_WEEK2 += WEEK2 || 0;
                    tot_WEEK3 += WEEK3 || 0;
                    tot_WEEK4 += WEEK4 || 0;
                    tot_WEEK5 += WEEK5 || 0;
                    tot_WEEK6 += WEEK6 || 0;
                    if (avg5 > 0) cnt_avg5++;
                    if (avg7 > 0) cnt_avg7++;
                    if (avg10 > 0) cnt_avg10++;
                    if (nps > 0) cnt_nps++;
                  });

                  if (cnt_avg5 > 0) tot_avg5 = Number((tot_avg5 / cnt_avg5).toFixed(2));
                  if (cnt_avg7 > 0) tot_avg7 = Number((tot_avg7 / cnt_avg7).toFixed(2));
                  if (cnt_avg10 > 0) tot_avg10 = Number((tot_avg10 / cnt_avg10).toFixed(2));
                  if (cnt_nps > 0) tot_nps = Number((tot_nps / cnt_nps).toFixed(2));

                  return (
                    <>
                      <Table.Summary.Row style={{backgroundColor:'#f7f7f7'}}>
                        <Table.Summary.Cell  index={0} align='center'>합계</Table.Summary.Cell>
                        <Table.Summary.Cell  index={1} align='center'>{tot_time1}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={2} align='center'>{tot_time2}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={3} align='center'>{tot_time1+tot_time2}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={4} align='center'>{tot_avg5}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={5} align='center'>{tot_avg7}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={6} align='center'>{tot_avg10}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={7} align='center'>{tot_nps}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={8} align='center'>{tot_WEEK1}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={9} align='center'>{tot_WEEK2}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={10} align='center'>{tot_WEEK3}</Table.Summary.Cell>
                        <Table.Summary.Cell  index={11} align='center'>{tot_WEEK4}</Table.Summary.Cell>
                        {(weekList.length > 4) && (<Table.Summary.Cell  index={12} align='center'>{tot_WEEK5}</Table.Summary.Cell>)}
                        {(weekList.length > 5) && (<Table.Summary.Cell  index={13} align='center'>{tot_WEEK6}</Table.Summary.Cell>)}
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            </TableWrapper> 
          </Spin>
        </Space>   
             
    </CardLayout>
  )
};

export default  Schedule;    